import React from 'react';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import styled from 'styled-components';

const SkeletonWrapper = styled.div`
  width: 100%;
`;
export const CurrencyLineSkeleton = () => (
  <SkeletonWrapper data-testid="currency-line-skeleton">
    <SkeletonTheme color={Styles.color.grey.four}>
      <Skeleton height="15px" width="100%" />
    </SkeletonTheme>
  </SkeletonWrapper>
);
